import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import FlexBox from 'components/common/FlexBox';
import HierarchyDetailsComponent from './HierarchyDetailsComponent';
import { parseId } from 'utils/functions';
import HierarchyHeaderComponent from './HierarchyHeaderComponent';
import { isDistrictDirtyVar, selectedCityIdsVar, selectedDistrictIdsVar, shouldRefetchListVar } from 'features/city/variables';

const HierarchyEditContainer = ({ id }) => {
  const internalId = useMemo(() => parseId(id), [id]);

  useEffect(
    () => () => {
      selectedDistrictIdsVar([]);
      selectedCityIdsVar([]);
      shouldRefetchListVar(false);
      isDistrictDirtyVar(false);
    },
    []
  );

  return (
    <FlexBox column gap={2}>
      <HierarchyHeaderComponent id={internalId} />
      {internalId && <HierarchyDetailsComponent id={id} />}
    </FlexBox>
  );
};

HierarchyEditContainer.propTypes = {
  id: PropTypes.number
};

export default HierarchyEditContainer;
